import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { QuickQuotes } from './components/QuickQuotes';
import { ProblemSection } from './components/ProblemSection';
import { SystemIntro } from './components/SystemIntro';
import { Coverage } from './components/Coverage';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { OfferSection } from './components/OfferSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FormatSection } from './components/FormatSection';
import { Faq } from './components/Faq';
import { BeforeAfter } from './components/BeforeAfter';
import { FinalCta } from './components/FinalCta';
import { FinalThoughts } from './components/FinalThoughts';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
interface AppProps {
  showUrgencyBar?: boolean;
}
export function App({
  showUrgencyBar = true
}: AppProps) {
  return <div className="min-h-full w-full bg-cream font-sans" data-id="element-0" data-mp="3ml1234bj9ggw">
      {showUrgencyBar ? <UrgencyBar data-id="element-1" data-mp="3rc9ca2kot5v4" /> : null}
      <Hero data-id="element-2" data-mp="3rbzo8kj7d8s2" />
      <main data-id="element-3" data-mp="3rdki07xp0nov">
        <StatsBar data-id="element-4" data-mp="3rcswjpxt86cb" />
        <QuickQuotes data-id="element-5" data-mp="3reccfffk0fdk" />
        <ProblemSection data-id="element-6" data-mp="5osn3wyp084" />
        <SystemIntro data-id="element-7" data-mp="680frswe88f" />
        <Coverage data-id="element-8" data-mp="5gel8p3rovc" />
        <Volumes data-id="element-9" data-mp="82kz509bybz" />
        <Bonuses data-id="element-10" data-mp="2zl3alhpbj03q" />
        <OfferSection data-id="element-11" data-mp="2zlle8zeb8glo" />
        <Testimonials data-id="element-12" data-mp="2zm4xqkjlzd1t" />
        <Guarantee data-id="element-13" data-mp="2zmwj72jhrued" />
        <FormatSection data-id="element-14" data-mp="2zng32ospcsv1" />
        <Faq data-id="element-15" data-mp="33m5be2yvvk7t" />
        <BeforeAfter data-id="element-16" data-mp="33lx02fiesmyq" />
        <FinalCta data-id="element-17" data-mp="33n6zp94wu37h" />
        <FinalThoughts data-id="element-18" data-mp="33orhrza1ftog" />
        <Contact data-id="element-19" data-mp="38lrpsfqg76i7" />
      </main>
      <Footer data-id="element-20" data-mp="38li619vzxvky" />
    </div>;
}